import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, vModelSelect as _vModelSelect, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row py-3 mx-1 px-4" }
const _hoisted_2 = { class: "col-12 row g-0 d-flex" }
const _hoisted_3 = { class: "col-12 col-lg-6 pe-lg-3" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "referral-reason" }, [
  /*#__PURE__*/_createTextVNode(" Referral Reason "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_6 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_7 = { class: "form-group col-12 col-lg-4 pe-lg-2" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { for: "referral-date" }, [
  /*#__PURE__*/_createTextVNode(" Referral Date "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_10 = { class: "input-group date datepickerInput" }
const _hoisted_11 = ["value"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_13 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { for: "referral-service-location" }, " Patient Current Location ", -1 /* HOISTED */)
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { for: "inquiry-date" }, " Inquiry Date ", -1 /* HOISTED */)
const _hoisted_18 = { class: "input-group date datepickerInput" }
const _hoisted_19 = ["value"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_21 = {
  key: 0,
  class: "text-secondary"
}
const _hoisted_22 = { class: "form-group col-12 d-flex flex-column" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { for: "source-of-referral" }, [
  /*#__PURE__*/_createTextVNode(" Referral Source "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_24 = {
  key: 0,
  class: "d-flex flex-wrap"
}
const _hoisted_25 = ["id", "checked", "value"]
const _hoisted_26 = ["for"]
const _hoisted_27 = { class: "me-1" }
const _hoisted_28 = { class: "col-12 card flex-row py-2 px-3 row g-0 mb-2" }
const _hoisted_29 = { class: "form-group col-12 col-lg-4 pe-lg-3" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { for: "referral-source" }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createTextVNode("Facility Name "),
    /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
  ])
], -1 /* HOISTED */)
const _hoisted_31 = { class: "form-group col-12 col-lg-4 pe-lg-3" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", { for: "referral-name" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Facility Point of Contact Name")
], -1 /* HOISTED */)
const _hoisted_33 = { class: "form-group col-12 col-lg-4 pe-lg-3" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", { for: "referring-provider" }, " Referring Provider ", -1 /* HOISTED */)
const _hoisted_35 = { class: "form-group col-12 col-lg-3 pe-lg-2" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", { for: "community-liaison" }, " Community Liaison ", -1 /* HOISTED */)
const _hoisted_37 = { class: "form-group col-12 col-lg-4 pe-lg-3" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", { for: "referral-source" }, [
  /*#__PURE__*/_createTextVNode(" Referring Provider Name "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_39 = { class: "form-group col-12 col-lg-4 pe-lg-3" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", { for: "referral-name" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Provider Point of Contact Name")
], -1 /* HOISTED */)
const _hoisted_41 = { class: "form-group col-12 col-lg-4 pe-lg-3" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("label", { for: "referring-facility" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Referring Facility")
], -1 /* HOISTED */)
const _hoisted_43 = { class: "form-group col-12 col-lg-3 pe-lg-2" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", { for: "community-liaison" }, " Community Liaison ", -1 /* HOISTED */)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1 /* HOISTED */)
const _hoisted_46 = { class: "form-group col-12 col-lg-4 pe-lg-2" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("label", { for: "internal-referral-source" }, [
  /*#__PURE__*/_createTextVNode(" Other Referral Source Name "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_48 = { class: "form-group col-12 col-lg-4 pe-lg-2" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("label", { for: "referral-source" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Relationship")
], -1 /* HOISTED */)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select Relationship", -1 /* HOISTED */)
const _hoisted_51 = ["value"]
const _hoisted_52 = { class: "form-group col-12 col-lg-3 pe-lg-2" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("label", { for: "community-liaison" }, " Community Liaison ", -1 /* HOISTED */)
const _hoisted_54 = { class: "form-group col-12 col-lg-4 pe-lg-2" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("label", { for: "internal-referral-source-name" }, [
  /*#__PURE__*/_createTextVNode(" Internal Referral Source Name "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_56 = { class: "form-group col-12 col-lg-4 pe-lg-2" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("label", { for: "internal-referral-source" }, " Internal Referral Source ", -1 /* HOISTED */)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("option", { value: 0 }, "Select Source", -1 /* HOISTED */)
const _hoisted_59 = ["value"]
const _hoisted_60 = { class: "form-group col-12 col-lg-3 pe-lg-2" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("label", { for: "community-liaison" }, " Community Liaison ", -1 /* HOISTED */)
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1 /* HOISTED */)
const _hoisted_63 = { class: "form-group col-12 col-lg-4 pe-lg-2" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("label", { for: "referral-comments" }, " Comments ", -1 /* HOISTED */)
const _hoisted_65 = { class: "form-group col-12 col-lg-4" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("label", { for: "referral-reason" }, " Pending Reason ", -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_TypeaheadInput = _resolveComponent("TypeaheadInput")!
  const _component_CommentInput = _resolveComponent("CommentInput")!
  const _component_PendingReason = _resolveComponent("PendingReason")!
  const _component_FormSection = _resolveComponent("FormSection")!

  return (_openBlock(), _createBlock(_component_FormSection, {
    title: "Referral Information",
    "full-height": false,
    "application-id": _ctx.application
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _withDirectives(_createElementVNode("textarea", {
                class: _normalizeClass(["form-control", `${
                                    _ctx.v$.patientDetails.referralInformation.referralReason.$error ? 'field-invalid' : ''
                                }`]),
                name: "referral-reason",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.patientDetails.referralInformation.referralReason) = $event)),
                placeholder: "Enter Reason",
                maxlength: "500",
                onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.v$.patientDetails.referralInformation.referralReason.$touch && _ctx.v$.patientDetails.referralInformation.referralReason.$touch(...args))),
                onChange: _cache[2] || (_cache[2] = (e) => _ctx.handleAllInput(e.target.value, 'referralReason'))
              }, null, 34 /* CLASS, HYDRATE_EVENTS */), [
                [_vModelText, _ctx.patientDetails.referralInformation.referralReason]
              ])
            ]),
            (_ctx.v$.patientDetails.referralInformation.referralReason.$error)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Referral reason is required."))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createVNode(_component_DatePicker, {
                options: _ctx.datePickerOptions,
                getDate: _ctx.handleDateChange
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("input", {
                      name: "referralDate",
                      type: "text",
                      class: _normalizeClass(["form-control", `${
                                            _ctx.v$.patientDetails.referralInformation.referralDate.$error
                                                ? 'field-invalid'
                                                : ''
                                        }`]),
                      placeholder: "MM/DD/YYYY",
                      value: _ctx.formatDateInput(_ctx.patientDetails.referralInformation.referralDate),
                      onChange: _cache[3] || (_cache[3] = (e) => _ctx.handleDateChange(e.target.value, e.target.name)),
                      autocomplete: "off",
                      onBlur: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.v$.patientDetails.referralInformation.referralDate.$touch && _ctx.v$.patientDetails.referralInformation.referralDate.$touch(...args)))
                    }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_11),
                    _hoisted_12,
                    (_ctx.v$.patientDetails.referralInformation.referralDate.$error)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.v$.patientDetails.referralInformation.referralDate.$errors[0].$message), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ])
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["options", "getDate"])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _withDirectives(_createElementVNode("input", {
                class: "form-control",
                name: "referral-service-location",
                maxlength: "50",
                type: "text",
                placeholder: "Enter Current Location",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.patientDetails.referralInformation.patientCurrentLocation) = $event))
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, _ctx.patientDetails.referralInformation.patientCurrentLocation]
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createVNode(_component_DatePicker, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("input", {
                      id: "inquiry-date",
                      name: "inquiryDate",
                      type: "text",
                      class: "form-control",
                      placeholder: "MM/DD/YYYY",
                      value: _ctx.formatDateInput(_ctx.patientDetails.referralInformation.inquiryDate),
                      autocomplete: "off",
                      disabled: ""
                    }, null, 8 /* PROPS */, _hoisted_19),
                    _hoisted_20
                  ]),
                  (!_ctx.patientDetails.referralInformation.inquiryDate)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_21, "Not Applicable"))
                    : _createCommentVNode("v-if", true)
                ]),
                _: 1 /* STABLE */
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            (_ctx.referralSources.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.referralSources, (source) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: source.id,
                      class: "form-check custom-radio form-check-inline d-inline"
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        id: `source-of-referral-${source.name}`,
                        class: "form-check-input",
                        name: "source-of-referral",
                        checked: _ctx.patientDetails.referralInformation.sourceOfReferral === source.value,
                        value: source.value,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.patientDetails.referralInformation.sourceOfReferral) = $event)),
                        onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.sourceOfReferralUpdated()))
                      }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_25), [
                        [_vModelRadio, _ctx.patientDetails.referralInformation.sourceOfReferral]
                      ]),
                      _createElementVNode("label", {
                        class: "form-check-label",
                        for: `source-of-referral-${source.name}`
                      }, [
                        _createElementVNode("span", _hoisted_27, _toDisplayString(source.name), 1 /* TEXT */)
                      ], 8 /* PROPS */, _hoisted_26)
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("section", _hoisted_28, [
            (_ctx.patientDetails.referralInformation.sourceOfReferral == 1)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_29, [
                    _hoisted_30,
                    _createVNode(_component_TypeaheadInput, {
                      getData: _ctx.getVendorList,
                      value: _ctx.facility,
                      onValueChanged: _ctx.updateFacility,
                      placeholder: "Start Typing..."
                    }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged"])
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _hoisted_32,
                    _withDirectives(_createElementVNode("input", {
                      class: "form-control",
                      maxlength: "50",
                      type: "text",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.patientDetails.referralInformation.facilityReferralSourceContactName) = $event)),
                      placeholder: "Enter Name"
                    }, null, 512 /* NEED_PATCH */), [
                      [_vModelText, _ctx.patientDetails.referralInformation.facilityReferralSourceContactName]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _hoisted_34,
                    _createVNode(_component_TypeaheadInput, {
                      getData: _ctx.getPhysicianList,
                      value: _ctx.referringProvider,
                      onValueChanged: _ctx.updateReferringProvider,
                      "init-value": _ctx.referringProvider,
                      placeholder: "Search Referring Provider"
                    }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged", "init-value"])
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _hoisted_36,
                    _createVNode(_component_TypeaheadInput, {
                      getData: _ctx.getUsersByRole,
                      value: _ctx.communityLiaison,
                      onValueChanged: _ctx.updateCommunityLiaison,
                      "init-value": _ctx.communityLiaison,
                      placeholder: "Search Community Liaison"
                    }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged", "init-value"])
                  ])
                ], 64 /* STABLE_FRAGMENT */))
              : _createCommentVNode("v-if", true),
            (_ctx.patientDetails.referralInformation.sourceOfReferral == 2)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_37, [
                    _hoisted_38,
                    _createVNode(_component_TypeaheadInput, {
                      getData: _ctx.getPhysicianList,
                      value: _ctx.physician,
                      onValueChanged: _ctx.updatePhysician,
                      "init-value": _ctx.physician,
                      placeholder: "Start Typing..."
                    }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged", "init-value"])
                  ]),
                  _createElementVNode("div", _hoisted_39, [
                    _hoisted_40,
                    _withDirectives(_createElementVNode("input", {
                      class: "form-control",
                      maxlength: "50",
                      type: "text",
                      placeholder: "Enter Name",
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.patientDetails.referralInformation.physicianReferralSourceContactName) = $event))
                    }, null, 512 /* NEED_PATCH */), [
                      [_vModelText, _ctx.patientDetails.referralInformation.physicianReferralSourceContactName]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_41, [
                    _hoisted_42,
                    _createVNode(_component_TypeaheadInput, {
                      getData: _ctx.getVendorList,
                      value: _ctx.referringFacility,
                      onValueChanged: _ctx.updateReferringFacility,
                      placeholder: "Search Referring Facility"
                    }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged"])
                  ]),
                  _createElementVNode("div", _hoisted_43, [
                    _hoisted_44,
                    _createVNode(_component_TypeaheadInput, {
                      getData: _ctx.getUsersByRole,
                      value: _ctx.communityLiaison,
                      onValueChanged: _ctx.updateCommunityLiaison,
                      "init-value": _ctx.communityLiaison,
                      placeholder: "Search Community Liaison"
                    }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged", "init-value"])
                  ]),
                  _hoisted_45
                ], 64 /* STABLE_FRAGMENT */))
              : _createCommentVNode("v-if", true),
            (_ctx.patientDetails.referralInformation.sourceOfReferral == 3)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createElementVNode("div", _hoisted_46, [
                    _hoisted_47,
                    _withDirectives(_createElementVNode("input", {
                      class: "form-control",
                      maxlength: "50",
                      type: "text",
                      placeholder: "Enter Name of Referral Source",
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.patientDetails.referralInformation.otherReferralSourceName) = $event))
                    }, null, 512 /* NEED_PATCH */), [
                      [_vModelText, _ctx.patientDetails.referralInformation.otherReferralSourceName]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_48, [
                    _hoisted_49,
                    _withDirectives(_createElementVNode("select", {
                      name: "relationship",
                      class: "form-select",
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.patientDetails.referralInformation.otherReferralSourceRelationship) = $event))
                    }, [
                      _hoisted_50,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.relationships, (rel) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: rel.name,
                          value: rel.value
                        }, _toDisplayString(rel.name), 9 /* TEXT, PROPS */, _hoisted_51))
                      }), 128 /* KEYED_FRAGMENT */))
                    ], 512 /* NEED_PATCH */), [
                      [_vModelSelect, _ctx.patientDetails.referralInformation.otherReferralSourceRelationship]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_52, [
                    _hoisted_53,
                    _createVNode(_component_TypeaheadInput, {
                      getData: _ctx.getUsersByRole,
                      value: _ctx.communityLiaison,
                      onValueChanged: _ctx.updateCommunityLiaison,
                      "init-value": _ctx.communityLiaison,
                      placeholder: "Search Community Liaison"
                    }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged", "init-value"])
                  ])
                ], 64 /* STABLE_FRAGMENT */))
              : _createCommentVNode("v-if", true),
            (_ctx.patientDetails.referralInformation.sourceOfReferral == 4)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  _createElementVNode("div", _hoisted_54, [
                    _hoisted_55,
                    _createVNode(_component_TypeaheadInput, {
                      getData: _ctx.getUsersByRole,
                      value: _ctx.internalReferralSourceName,
                      onValueChanged: _ctx.updateInternalReferralSourceName,
                      "init-value": _ctx.internalReferralSourceName,
                      placeholder: "Start Typing..."
                    }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged", "init-value"])
                  ]),
                  _createElementVNode("div", _hoisted_56, [
                    _hoisted_57,
                    _withDirectives(_createElementVNode("select", {
                      name: "internalReferralSource",
                      class: "form-select",
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.patientDetails.referralInformation.internalReferralSource) = $event)),
                      onChange: _cache[13] || (_cache[13] = ($event: any) => (
                                        _ctx.onReferralSourceChange(
                                            _ctx.patientDetails.referralInformation.internalReferralSource
                                        )
                                    ))
                    }, [
                      _hoisted_58,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.InternalReferralSourceEnum, (data) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: data.name,
                          value: data.value
                        }, _toDisplayString(data.name), 9 /* TEXT, PROPS */, _hoisted_59))
                      }), 128 /* KEYED_FRAGMENT */))
                    ], 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                      [_vModelSelect, _ctx.patientDetails.referralInformation.internalReferralSource]
                    ])
                  ]),
                  _createCommentVNode(" <div class=\"form-group col-12 col-lg-4 pe-lg-3\">\r\n                                <label for=\"referring-facility\">\r\n                                    <span>Referring Facility</span>\r\n                                </label>\r\n                                <TypeaheadInput\r\n                                    :getData=\"getVendorList\"\r\n                                    :value=\"referringFacility\"\r\n                                    v-on:valueChanged=\"updateReferringFacility\"\r\n                                    placeholder=\"Search Referring Facility\"\r\n                                />\r\n                            </div> "),
                  _createElementVNode("div", _hoisted_60, [
                    _hoisted_61,
                    _createVNode(_component_TypeaheadInput, {
                      getData: _ctx.getUsersByRole,
                      value: _ctx.communityLiaison,
                      onValueChanged: _ctx.updateCommunityLiaison,
                      "init-value": _ctx.communityLiaison,
                      placeholder: "Search Community Liaison"
                    }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged", "init-value"])
                  ])
                ], 64 /* STABLE_FRAGMENT */))
              : _createCommentVNode("v-if", true)
          ]),
          _hoisted_62,
          _createElementVNode("div", _hoisted_63, [
            _hoisted_64,
            _createVNode(_component_CommentInput, {
              "input-name": "referral-comments",
              result: _ctx.patientDetails.referralInformation.comments,
              onResultUpdatedAppended: _ctx.resultUpdatedAppended,
              onResultUpdated: _ctx.resultUpdated,
              placeholder: "Enter Comments",
              "class-list": _ctx.commentInputClass,
              application: _ctx.application
            }, null, 8 /* PROPS */, ["result", "onResultUpdatedAppended", "onResultUpdated", "class-list", "application"])
          ]),
          _createElementVNode("div", _hoisted_65, [
            _hoisted_66,
            _createVNode(_component_PendingReason, {
              "input-name": "referral-reason",
              result: _ctx.patientDetails.referralInformation.pendingReasonComment,
              classList: _ctx.commentInputClass,
              maxLength: 250,
              placeholder: "Enter Comments"
            }, null, 8 /* PROPS */, ["result", "classList"])
          ])
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["application-id"]))
}